import {Component, OnInit} from '@angular/core';
import {Option} from './option-row/option';
import {Router} from '@angular/router';
import {SharedEligibilityCheckForm} from '../eligibility-check-form/eligibility-check-form.component';
import {CreditOptionsCategorizer} from './credit-options-categorizer';
import {Keys, StorageService} from '../../../service/storage.service';
import {EligibilityCheckService} from '../../../service/eligibility-check.service';
import {SelectedOption} from './option-row/selected-option';
import {CreditOptions} from '../../../model/eligibility-check/credit-options.model';
import {ChannelPartnerService} from '../../../service/channel-partner.service';
import {SubventionPreferenceService} from '../../../service/subvention-preference.service';
import {SubventionPreference} from '../../../model/subvention-preference.model';
import {ChannelPartner} from '../../../model/channel-partner.model';

@Component({
    templateUrl: './options.component.html',
    styleUrls: ['./options.component.scss']
})
export class OptionsComponent implements OnInit {
    static readonly EXTRA_STATE = Keys.EXTRA_OPTIONS_STATE;

    defaultOptions: Option[] = [];
    maximizedLoanAmountOptions: Option[] = [];
    public partnerDetails: ChannelPartner;
    public partnerPreference: SubventionPreference;
    public sharedForm: SharedEligibilityCheckForm;

    constructor(private router: Router, private categorizer: CreditOptionsCategorizer,
                protected storageService: StorageService, private eligibilityCheckService: EligibilityCheckService,
                private channelPartnerService: ChannelPartnerService, private subventionPreferenceService: SubventionPreferenceService) {
    }

    async ngOnInit(): Promise<void> {
        const state = this.storageService.getObject<{ creditOptions: CreditOptions, eligibilityCheckForm: SharedEligibilityCheckForm }>(OptionsComponent.EXTRA_STATE);
        this.keepState(state);
        await this.populatePartnerDetails();
        this.partnerPreference = await this.getPartnerPreference();
    }

    async applyForLoan(option?: Option): Promise<void> {
        if (option) {
            const userId = this.storageService.getItem(Keys.PROFILE_ID);
            const selectedOption = new SelectedOption(userId, option.id);
            const selectedOptionId = await this.eligibilityCheckService.selectCreditOption(selectedOption);

            this.storageService.saveItem(Keys.SELECTED_CREDIT_OPTION_ID, selectedOptionId);
            this.storageService.saveObject(Keys.SELECTED_CREDIT_OPTION, option);
            this.storageService.removeItem(Keys.LOAN_REASON);
        }

        await this.router.navigate(['/borrow/intro'], {
            queryParams: {'channel-partner-id': this.sharedForm.partnerId}
        });
    }

    totalFoundOptions(): number {
        return this.defaultOptions.length + this.maximizedLoanAmountOptions.length;
    }

    maximumEligibleLoanAmount(): number {
        return this.maximizedLoanAmountOptions[0].amount;
    }

    async populatePartnerDetails(): Promise<void> {
        this.partnerDetails = await this.channelPartnerService.getPartnerDetails(this.sharedForm.partnerId);
    }

    isProcessingFeeSubvented(): boolean {
        const isProcessingFeeSubvented = !!this.partnerPreference && !!this.partnerPreference.processingFeeSubventionPercentage && this.partnerPreference.processingFeeSubventionPercentage > 0;
        return isProcessingFeeSubvented;
    }

    protected async getPartnerPreference(): Promise<SubventionPreference> {
        return await this.subventionPreferenceService.get(this.sharedForm.partnerId);
    }

    protected keepState(state: { [p: string]: any }) {
        if (state.creditOptions) {
            const categorizedOptions = this.categorizer.categorize(state.creditOptions, state.eligibilityCheckForm);
            this.defaultOptions = categorizedOptions.defaultOptions;
            this.maximizedLoanAmountOptions = categorizedOptions.maximizedLoanAmountOptions;
        }

        this.sharedForm = state.eligibilityCheckForm;
    }
}
